import { render, staticRenderFns } from "./StartSheet.vue?vue&type=template&id=1fb691ec&"
import script from "./StartSheet.vue?vue&type=script&lang=js&"
export * from "./StartSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports